export default {
  option: {
    border: {
      radius: '50px',
    },
    padding: {
      vertical: '0.3125rem',
      horizontal: '0.9375rem',
    },
    fontSize: '1rem',
  },
  border: {
    thickness: '1px',
    style: 'solid',
  },
};
